import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgCardGiftLine = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M1 8a4 4 0 0 1 4-4h14a4 4 0 0 1 4 4v8a4 4 0 0 1-4 4H5a4 4 0 0 1-4-4zm2 0a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v1.5h-2q-.076 0-.15.011a3.024 3.024 0 0 0-4.392-1.617L12 9.34 9.542 7.894A3.024 3.024 0 0 0 5.15 9.51 1 1 0 0 0 5 9.5H3zm15.026 4.738c.39-.355.665-.787.824-1.25q.074.012.15.012h2V16a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4.5h2q.077 0 .15-.011a3.024 3.024 0 0 0 4.392 1.618l.052-.032-.488.978a1 1 0 1 0 1.788.894L12 12.737l1.106 2.21a1 1 0 1 0 1.788-.894l-.488-.978.052.031a3.02 3.02 0 0 0 3.568-.368m-9.498-3.12a1.024 1.024 0 1 0 0 1.765l1.5-.883zm5.444.882 1.5.883a1.024 1.024 0 1 0 0-1.765z'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgCardGiftLine)
export default ForwardRef
